var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSignOut = function SvgSignOut(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#094262",
    d: "M5.49 4.49v11.02h6.85V17H4V3h8.34v1.49H5.49Zm6.3 9.88-1.05-1.06 2.57-2.57H7.28V9.26h6.03l-2.57-2.57 1.05-1.06L16.16 10l-4.37 4.37Z"
  })));
};
export default SvgSignOut;